//
// LanguageTag.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import ClosetObject from "../../ClosetObject";
import "../../lib";

var LanguageTag = createModule("commons::LanguageTag", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        asOriginalString: [7],
        getSASLegacyLocale: [7],
        asCanonicalString: [7],
        isPseudo: [2],
    },
    {
        _create: [4,7],
    },
    ,
]);
export default LanguageTag;
